var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackwardFeatureSelectionOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.5C15.2467 19.5 19.5 15.2467 19.5 10C19.5 4.75329 15.2467 0.5 10 0.5C4.75329 0.5 0.5 4.75329 0.5 10C0.5 15.2467 4.75329 19.5 10 19.5Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0004 6.70004V13.301C13.0004 13.5591 12.8281 13.6883 12.754 13.7319C12.6799 13.7755 12.4832 13.8634 12.2576 13.7381L6.31675 10.4376C6.08463 10.3086 6.05957 10.089 6.05957 10.0005C6.05957 9.91207 6.08463 9.69241 6.31675 9.56345L12.2576 6.26297C12.4832 6.13764 12.6799 6.22551 12.754 6.26911C12.8281 6.31271 13.0004 6.44197 13.0004 6.70004Z",
    fill: "#AECDFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55957 10.0008L12.5004 13.3013V6.70033L6.55958 10.0008C6.55957 10.0008 6.55957 10.0008 6.55957 10.0008ZM5.55957 10.0008C5.55957 9.65898 5.73102 9.31716 6.07393 9.12665L12.0148 5.82617C12.6813 5.45587 13.5004 5.93784 13.5004 6.70032V13.3013C13.5004 14.0638 12.6813 14.5458 12.0148 14.1755L6.07393 10.875C5.73102 10.6845 5.55957 10.3426 5.55957 10.0008Z",
    fill: "#AECDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwardFeatureSelectionOperationIcon);
export default __webpack_public_path__ + "static/media/BackwardFeatureSelectionOperationIcon.7f649ddff358e62776420ebdde192dc3.svg";
export { ForwardRef as ReactComponent };